module.exports = __webpack_public_path__ + "static/media/checkout-secret.08b4bc0d.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/winter-2019/checkout-secret.png
// module id = 152
// module chunks = 0